import { getScribeHttpClients } from '@heidi/api/client';

interface ScribeHttp {
  get<T>(url: string, config: { timeout: number }): Promise<{ data: T }>;
}

/** The shared client sets no deadline; a stalled appliance must not hang the read. */
const CAPABILITIES_TIMEOUT_MS = 5_000;

const http = (): ScribeHttp => getScribeHttpClients().scribeHttpV2;

const isNotFound = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  (error as { response?: { status?: unknown } }).response?.status === 404;

/**
 * `GET /chat/capabilities` — what Evidence chat can do in this deployment
 * (MOD-1726). Served on the router the completions call uses.
 *
 * The body is returned unvalidated: `resolveEvidenceCapabilities` is the one
 * place it is read. A 404 is an answer rather than a failure — a backend
 * older than the route reports nothing, which resolves to the most restrictive
 * value — so it resolves to `null` instead of being retried or refetched.
 */
export async function getChatCapabilities(): Promise<unknown> {
  try {
    const { data } = await http().get<unknown>('/chat/capabilities', {
      timeout: CAPABILITIES_TIMEOUT_MS,
    });
    return data ?? null;
  } catch (error) {
    if (isNotFound(error)) return null;
    throw error;
  }
}
